exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tab-panel {\n  width: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/components/tab/tab-panel.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,oBAAoB;MAChB,mBAAmB;UACf,eAAe;CACxB","file":"tab-panel.vue","sourcesContent":["\n.tab-panel {\n  width: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6682b078","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tab/tab-panel.vue
// module id = p21o
// module chunks = 83